
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link",
      function () {
        return require("private-next-pages/docs/link/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link"])
      });
    }
  